module.exports = __webpack_public_path__ + "img/check-24px.e294285e.svg";